import { createContext } from 'react';

const PartnerPayContext = createContext({});
export const { Provider } = PartnerPayContext;
export default PartnerPayContext;
